<template>
    <layout-card
        :error="error"
        :loading="loading"
        :type="settings.context"
        :isCustomizable="settings.isCustomizable"
        @edit-card="toggleSettingsForm"
        @hide-card="$emit('hide-card', type)"
        @refresh-card="fetchCard(type, {}, true)"
        class="card-invoice-unreconciledCard"
        >
        
        <!-- SLOTED TITLE -->
        <template #title>{{ name }}</template>

        <!-- SLOTED CONTENT -->
        <template #content>
            <template-kpi-card :data="{'stats': cardData, 'labels': labels}" />

            <!-- portal for overlay -->
            <portal to="dashboardSettingsForm">
                <card-setting-overlay
                    v-if="showSettingsForm"
                    :formName="settingsFormName"
                    :cardCustomSettings="customSettings"
                    :cardName="type"
                    @fetched="fetchCard"
                    @close-form="toggleSettingsForm"
                    @custom-settings-saved="fetchCard(type, {}, true)"
                />
            </portal>
        </template>

        <!-- SLOTED FOOTER -->
        <template #footer>
            <fiscal-year-footer :fiscalYearTimestamp="fiscalYear"></fiscal-year-footer>
        </template>

    </layout-card>
</template>

<script>
    import LayoutCard from './LayoutCard.vue';
    import CardMixin from './CardMixin.js';
    import TemplateKpiCard from './TemplateKpiCard.vue'
    import FiscalYearFooter from './FiscalYearFooter.vue'

    export default {
        mixins : [CardMixin],
        data() {
            return {
                labels: {
                    invoice: {
                        label: this.$l10n.__("Factures de ventes à rapprocher"),
                        labelCount: this.$l10n.__("Factures"),
                        labelAmount: this.$l10n.__("Potentiel")
                    },
                    purinvoice: {
                        label: this.$l10n.__("Factures d'achats à rapprocher"),
                        labelCount: this.$l10n.__("Factures"),
                        labelAmount: this.$l10n.__("Potentiel")
                    }
                },
                settingsFormName : 'invoice-unreconciled-setting-form',
            }
        },
        components: {
            LayoutCard,
            TemplateKpiCard,
            FiscalYearFooter
        }
    }
</script>